import UploadFileML from './UploadFileML';
export default (props) => {
  return <UploadFileML {...props} />;
};
